export const data_mPlus = {
   splat: "https://assets.deepworldmodel.ai/playground/scene/mPlus.sog",
   mesh: "https://assets.deepworldmodel.ai/playground/scene/mPlus_mesh.glb",
   avatar:
      "https://assets.deepworldmodel.ai/playground/avatar/labubuRun_20260630_1720.glb",
   scale: 0.3,
   camera: {
      position: {
         x: -4.57,
         y: 0.2176,
         z: -2.04,
      },
      target: {
         x: -3.73,
         y: 0.0513,
         z: -1.54,
      },
   },
   path: {
      position: [
         [1.7641403675079346, -0.30000039935112, 1.2968418598175049],
         [2.074362277984619, -0.3287310004234314, 1.346057653427124],
         [2.3555996417999268, -0.3257288634777069, 1.4611185789108276],
         [2.639770030975342, -0.32532626390457153, 1.5652836561203003],
         [2.930499792098999, -0.32765620946884155, 1.6527233123779297],
         [3.224324941635132, -0.3277823328971863, 1.7331616878509521],
         [3.521622896194458, -0.3278343677520752, 1.7911159992218018],
         [3.803856372833252, -0.32787930965423584, 1.6863203048706055],
         [4.02496862411499, -0.32757335901260376, 1.4827202558517456],
         [4.12368631362915, -0.32483455538749695, 1.198920726776123],
         [4.007755279541016, -0.3277979791164398, 0.9174677729606628],
         [3.730701208114624, -0.32455286383628845, 0.7978402376174927],
         [3.435237407684326, -0.3279460668563843, 0.7273062467575073],
         [3.139988422393799, -0.32740887999534607, 0.6580567359924316],
         [2.8449223041534424, -0.32817116379737854, 0.5879715085029602],
         [2.556608200073242, -0.3256757855415344, 0.4954609274864197],
         [2.287083387374878, -0.3243929147720337, 0.35285326838493347],
         [2.0196540355682373, -0.3277434706687927, 0.21111612021923065],
         [1.7534373998641968, -0.3235224187374115, 0.06276395916938782],
         [1.496480941772461, -0.3276253938674927, -0.09834029525518417],
         [1.2383052110671997, -0.3275768756866455, -0.2587866485118866],
         [0.9679089188575745, -0.25422176718711853, -0.3831484317779541],
         [0.6656127572059631, -0.29671475291252136, -0.4643261134624481],
         [0.3610447645187378, -0.32344040274620056, -0.53377366065979],
         [0.05779041349887848, -0.3358558118343353, -0.5660472512245178],
         [-0.2469090223312378, -0.33333998918533325, -0.5889407992362976],
         [-0.5490142107009888, -0.3276679813861847, -0.5595178604125977],
         [-0.8509201407432556, -0.3270690441131592, -0.5380551218986511],
         [-1.1541887521743774, -0.32668522000312805, -0.5255575776100159],
         [-1.4568766355514526, -0.32323017716407776, -0.4914085268974304],
         [-1.7511131763458252, -0.32787203788757324, -0.42572471499443054],
         [-1.8557981252670288, -0.3278236389160156, -0.13771626353263855],
         [-1.8163145780563354, -0.325372576713562, 0.15978345274925232],
         [-1.5752500295639038, -0.3258730471134186, 0.36237791180610657],
         [-1.3053605556488037, -0.25498512387275696, 0.5056712031364441],
         [-1.0194261074066162, -0.25757306814193726, 0.628410816192627],
         [-0.7362154722213745, -0.32237204909324646, 0.7353212833404541],
         [-0.4434655010700226, -0.3274340331554413, 0.8172553181648254],
         [-0.1496388465166092, -0.32735463976860046, 0.8948231935501099],
         [0.14399072527885437, -0.32590630650520325, 0.9721370339393616],
         [0.4377470016479492, -0.3269355893135071, 1.049597978591919],
         [0.7312884330749512, -0.327745646238327, 1.1273351907730103],
         [1.024714469909668, -0.3277696967124939, 1.2054611444473267],
         [1.3196830749511719, -0.32717466354370117, 1.2780247926712036],
         [1.7641403675079346, -0.30000039935112, 1.2968418598175049],
      ],
      target: [
         [2.7347856824167347, -0.3285709619522095, 1.448276293236654],
         [3.0030197880188334, -0.3287310004234314, 1.7169959623910986],
         [3.284017405366261, -0.3257288634777069, 1.8326565396826522],
         [3.59234128722046, -0.32532626390457153, 1.8695992846634248],
         [3.8916165104871405, -0.32765620946884155, 1.9288657640850329],
         [4.19354014549538, -0.3277823328971863, 1.9793768145311348],
         [4.516147076621941, -0.3278343677520752, 1.6866092791266658],
         [4.636160505157432, -0.32787930965423584, 1.132001054513833],
         [4.565734401765741, -0.32757335901260376, 0.6415470431768654],
         [4.1401996121114, -0.32483455538749695, 0.19905708058568572],
         [3.2285044847730755, -0.3277979791164398, 0.2907555592185551],
         [2.7623987381078994, -0.32455286383628845, 0.5480596807703356],
         [2.4610997051526056, -0.3279460668563843, 0.5013510819432888],
         [2.166601378251177, -0.32740887999534607, 0.4288894121975905],
         [1.875468310836511, -0.32817116379737854, 0.3426982836253657],
         [1.6668643028096954, -0.3256757855415344, 0.03900085553896521],
         [1.40344780658398, -0.3243929147720337, -0.1153220837645923],
         [1.1364399430007641, -0.3277434706687927, -0.2578538859541012],
         [0.905558257717033, -0.3235224187374115, -0.4674255921344732],
         [0.6494029701193722, -0.3276253938674927, -0.6298089302093918],
         [0.3832784881409431, -0.3275768756866455, -0.7773705887587731],
         [0.03584637291295245, -0.25422176718711853, -0.7454458378509614],
         [-0.327214171982912, -0.29671475291252136, -0.5838865110754878],
         [-0.6389356021069948, -0.32344040274620056, -0.5275073728380144],
         [-0.9335001667434487, -0.3358558118343353, -0.43435448178431585],
         [-1.2416640876729215, -0.33333998918533325, -0.4866551209765217],
         [-1.5454344146839012, -0.3276679813861847, -0.4749792473730435],
         [-1.8498593652710753, -0.3270690441131592, -0.49200704159383934],
         [-2.1492835793470872, -0.32668522000312805, -0.426631924040706],
         [-2.4502255576182317, -0.32323017716407776, -0.3762654896404241],
         [-2.5494771075584906, -0.32787203788757324, 0.17645053635575425],
         [-1.898508966140995, -0.3278236389160156, 0.8613712121529686],
         [-1.336131768718428, -0.325372576713562, 1.0369518913152755],
         [-0.7288939772991418, -0.3258730471134186, 0.8949954413663036],
         [-0.4533965019536107, -0.25498512387275696, 1.0292714812219839],
         [-0.08458306246249281, -0.25757306814193726, 0.9834720522063594],
         [0.21042088334731524, -0.32237204909324646, 1.0576248829412485],
         [0.5233374219141578, -0.3274340331554413, 1.0727785228043354],
         [0.8174009991273441, -0.32735463976860046, 1.1494482844915157],
         [1.1110305709228077, -0.32590630650520325, 1.2267621248807674],
         [1.4044236392006977, -0.3269355893135071, 1.3055985223603106],
         [1.6979650706276996, -0.327745646238327, 1.383335734541402],
         [1.9910945952282675, -0.3277696967124939, 1.462578731144946],
         [2.2938435262322496, -0.32717466354370117, 1.5038818606585649],
         [2.7347856824167347, -0.3285709619522095, 1.448276293236654],
      ],
   },
};
